<template>
  <div class="comp-wrapper body">
    <div
      class="banner-top"
      :style="{
        'background-image': 'url(' + confetti + ')',
      }"
    >
      <div class="banner-items">
        <div>
          <img class="logo3" src="../../assets/logo3.png" />
        </div>

        <div>
          <img class="third" src="../../assets/3rd.png" />
        </div>

        <div>
          <h3 class="giveaway-text">Giveaway</h3>
        </div>
      </div>
    </div>

    <div class="poster-wrapper">
      <div class="partner">
        <img class="partners-img" src="../../assets/partners.png" />
      </div>
      <div class="cover-image">
        <img class="rupakot-resort" src="../../assets/resort.png" />
      </div>
    </div>

    <div
      class="campaign-wrapper"
      :style="{
        'background-image': 'url(' + confetti + ')',
      }"
    >
      <div class="rules-container">
        <h3 class="how-to-participate">
          Win a One Night Stay at Rupakot Resort
        </h3>

        <span> - You can bring an additional person with you </span>
        <span> - Round Trip Buddha Air Flight Tickets Included </span>
      </div>

      <div class="rules-container">
        <h3 class="how-to-participate">How To Participate</h3>
        <span
          >1. Follow
          <a
            class="highlight"
            href="https://instagram.com/khaanpin"
            target="_blank"
            >@khaanpin</a
          >
          ,
          <a
            class="highlight"
            href="https://instagram.com/khaanpin.pokhara"
            target="_blank"
            >@khaanpin.pokhara</a
          >
          ,
          <a
            class="highlight"
            href="https://instagram.com/tuborgnepal"
            target="_blank"
            >@tuborgnepal</a
          >
          and
          <a
            class="highlight"
            href="https://instagram.com/buddhaairnepal"
            target="_blank"
            >@buddhaairnepal</a
          >
          instagram page.
        </span>
        <span>
          2. <span class="highlight">Like and Tag a friend</span> with whom you
          would like to go to Rupakot Resort on the original post by
          <a
            class="highlight"
            href="https://instagram.com/khaanpin"
            target="_blank"
            >@khaanpin</a
          >
          and
          <a
            class="highlight"
            href="https://instagram.com/khaanpin.pokhara"
            target="_blank"
            >@khaanpin.pokhara</a
          >.
        </span>
        <span>
          3. <span class="highlight"> Download Buddha Air App</span> and send a
          screenshot (Private DM) for confirmation.
        </span>
        <span>
          4.Order food totalling<span class="highlight"> 2500 NRs</span> or more
          during the contest duration. (Total of single or multiple orders
          should be worth more than 2500 NRs)
        </span>
        <span>
          5. Payment should be made through
          <span class="highlight">Fonepay</span> in at least one order to be
          eligible to enter into the contest. The more your order, the more are
          your chances of winning.
        </span>
        <span>
          7. Purchase <span class="highlight">Tuborg</span> with any food orders
          at least once to be eligible to participate in this contest.
        </span>
        <span>
          6. Enter the promo code <span class="highlight">“THREE”</span> while
          checking out to validate your participation in the giveaway.
        </span>
      </div>

      <div class="rules-container">
        <h3 class="how-to-participate">Winners/Entry</h3>

        <span> 1. The winner will be determined by Khaanpin </span>
        <span>
          2. <span class="highlight">3 lucky winners</span> will be selected via
          lucky draw. The Winners will be declared on
          <span class="highlight"> September 25-30, 2021 </span>
        </span>
        <span>
          3. The declared winners will be eligible to win one night free stay at
          Rupakot Resort ( on Bed and Breakfast basis) along with a round flight
          trip to Pokhara.
        </span>
      </div>

      <div class="rules-container">
        <h3 class="how-to-participate">Disclaimer</h3>

        <span>
          1. The addition of people to the trip has to be borne by the winners
          themselves.
        </span>
        <span>
          2. Any beverages (hard and soft drinks) are not included during the
          stay.
        </span>
        <span>
          3. During the stay, any damage, loss, cost, and expenses shall be
          borne by the winners themselves.
        </span>
        <span>
          4. It is not possible to exchange any prize for its monetary worth.
        </span>
        <span>
          5. Participants are not allowed to exchange prizes offered and won by
          Khaanpin or appropriate affiliates, for other goods or money.
        </span>
        <span>
          6. There is no cash alternative to the prize and in case such a demand
          is made, Khaanpin reserves the right to cancel the prize or give it to
          the second-best nomination.
        </span>
        <span>
          7. In case the lucky winner denies the prize for any
          reason/situation/circumstances, Khaanpin reserves the right to cancel
          the prize/giveaway or give it to the second-best nomination.
        </span>
        <span>
          8. Khaanpin reserves the right to change the terms and conditions of
          this contest, including extending, withdrawing, or discontinuing the
          same without notice, without assigning any reason, at its sole
          discretion without any liability.
        </span>
        <span>
          9. If Khaanpin does not receive a claim to the offered prize by the
          winner, the prize will not be able to be claimed after 7 days.
        </span>
      </div>
    </div>

    <h3 class="easy-peasy">Easy Peasy! Best Wishes!</h3>

    <div>
      <div v-if="this.location === '1'">
        <CampaignList :list_id="36" />
      </div>
      <div v-if="this.location === '2'">
        <CampaignList :list_id="37" />
      </div>
    </div>

    <div class="button-container">
      <a-button type="primary" @click="onShopMore" class="checkout-button">
        Shop More →
      </a-button>
    </div>

    <FooterBar />
  </div>
</template>

<script>
import router from "../../router";

import CampaignList from "./CampaignList.vue";
import FooterBar from "../../components/FloatingFooter/FooterBar.vue";

import confett from "../../assets/confetti.png";
import infinity_pool from "../../assets/resort.png";

import { LocationId } from "../../services/storage.service";

import { mapActions } from "vuex";

export default {
  name: "Campaign",
  components: {
    CampaignList,
    FooterBar,
  },
  data() {
    return {
      confetti: confett,
      infinity: infinity_pool,
      location: "0",
      ktm: "36",
      pkr: "37",
    };
  },
  methods: {
    ...mapActions(["clearCart", "updateLocationId"]),

    onShopMore() {
      router.push("/:loc?");
    },
    onStartShopping() {
      window.scrollTo({
        top: 950,
        behavior: "smooth",
      });
    },

    getLocation() {
      let that = this;

      this.$confirm({
        title: "Please choose your delivery location",
        okText: "Pokhara",
        okType: "primary",
        cancelText: "Kathmandu",
        onOk() {
          that.location = "2";
          that.updateLocationId(2);
          LocationId.setLocationId(2);
          router.push("/p/3");
        },
        onCancel() {
          that.location = "1";
          that.updateLocationId(1);
          LocationId.setLocationId(1);
          router.push("/p/3");
        },
      });
    },
  },

  created() {
    this.getLocation();
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.banner-top {
  margin-top: 100px;
  width: 100%;

  .banner-items {
    width: 700px;
    text-align: center;
    margin: 0 auto;

    & > div {
      display: inline-block;
    }
  }
}

.logo3 {
  height: 95px;
}

.third {
  width: 200px;
}

.third-anniversary-text {
  text-transform: uppercase;
  text-align: center;
  color: skyblue;
  font-weight: 600px;
}

.giveaway-text {
  font-size: 70px;
  color: #ed1e29;
  font-family: "American-Lemon";
}

.poster-wrapper {
  background: transparent;
  margin-top: -200px;
  .rupakot-resort {
    margin-top: -200px;

    width: 100%;
    object-fit: cover;
  }

  .partner {
    width: 500px;
    margin: 0 auto;
    position: relative;
    z-index: 99;
    top: 260px;
    img {
      width: 100%;
    }
  }
}

.campaign-wrapper {
  font-family: "Montserrat", sans-serif;
  width: 100%;
  padding: 0;
  /* margin: 0; */
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.easy-peasy {
  color: gray;
  text-transform: uppercase;
  text-align: center;
  font-size: 20px;
  font-family: "Fredoka One", cursive;
  letter-spacing: 3px;
  margin: 40px 0px;
}

.rules-container {
  margin-top: 40px;
  margin-bottom: 10px;
  width: 650px;
  height: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  color: #525b76;
}

.rules-container .how-to-participate {
  align-self: center;
  font-size: 56px;
  font-weight: 600;
  font-family: "Stay-Classy-SLDT";
  letter-spacing: 2px;
  color: #ed1e29;
  background: rgba(255, 255, 255, 0.9);
  display: inline-block;
  border-radius: 10px;
  padding: 5px 0;
}

.rules-container span {
  margin: 5px 0;
  padding: 5px 0;
  font-size: 16px;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.9);
  display: inline-block;
  border-radius: 10px;
}

.rules-container .highlight {
  color: #ed1e29;
  font-weight: 800;
  margin-left: 3px;
}

.button-container {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkout-button {
  display: inline-block;
  padding: 10px;
  background-color: $brand-color;
  color: white;
  height: auto;
  cursor: pointer;
  font-family: $main-font;
  text-transform: uppercase;
  border-radius: 4px;
}

@media screen and (max-width: 700px) {
  .campaign-wrapper {
    width: 100%;
  }

  .rules-container {
    width: 90%;
  }

  .banner-items {
    width: 100% !important;

    & > div {
      display: block !important;
      margin: 0 auto;
    }
  }

  .poster-wrapper {
    margin-top: 0;
    .rupakot-resort {
      margin-top: -100px;
    }
    .partner {
      top: -40px;
      display: inline-block;

      .partners-img {
        text-align: center;
        width: 75%;
        margin: 0 auto;
        align-self: center;
      }
    }
  }
  .body {
    overflow: hidden !important;
  }
}
</style>